import { useApolloClient } from '@apollo/client';
import { getYuzu } from 'core/monitoring/Yuzu/Yuzu.utils';
import { MyRegionDocument, MyRegionQuery, useMyRegionQuery } from 'graphql/queries/__generated__/myRegion';
import { useCachedCurrentContact } from 'graphql/queries/cached';
import { useCallback, useEffect } from 'react';

export const useMyRegionMiddleware = () => {
  const client = useApolloClient();

  const { data } = useMyRegionQuery({
    onError: () => {
      client.writeQuery<MyRegionQuery>({
        query: MyRegionDocument,
        data: { myRegion: null },
      });
    },
  });

  return data;
};

export const useYuzuMetaMiddleware = () => {
  const { data } = useCachedCurrentContact();
  const userId = String(data?.currentContact?.id || '');

  const yuzu = getYuzu();

  const yuzuLogContextGetter: Parameters<typeof yuzu.setLogContextGetter>[0] = useCallback(
    ({ baseLogContextGetter }) => {
      return {
        ...baseLogContextGetter(),
        userId,
        activeExperiments: {},
      };
    },
    [userId],
  );

  useEffect(() => {
    yuzu.setLogContextGetter(yuzuLogContextGetter);
  }, [yuzu, yuzuLogContextGetter]);
};
